import * as z from "zod";

export const ChatbotMessageDtoSchema = z.object({
    content: z.string().trim(),
    role: z.enum(["user", "assistant", "error"]),
});

export type ChatbotMessageDto = z.output<typeof ChatbotMessageDtoSchema>;

export const ChatbotMessagesDtoSchema = z
    .object({
        history_conversation: z.array(ChatbotMessageDtoSchema),
    })
    .readonly();
export type ChatbotMessagesDto = z.output<typeof ChatbotMessagesDtoSchema>;
